/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Nav_Sign_InInputs */

const en_common_nav_sign_in = /** @type {(inputs: Common_Nav_Sign_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign In`)
};

/**
* | output |
* | --- |
* | "Sign In" |
*
* @param {Common_Nav_Sign_InInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_nav_sign_in = /** @type {((inputs?: Common_Nav_Sign_InInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Nav_Sign_InInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_nav_sign_in(inputs)
});
export { common_nav_sign_in as "common.nav.sign_in" }